export const fullWidthTable = {
  data () {
    return {
      containerWidth: 0,
      loading: false,
      page: 1,
      pageSize: 25,
      pageSizes: [25, 50, 100, 200],
      nonTableHeight: 425,
      showDialog: false,
      windowHeight: 0
    }
  },
  filters: {
    stripExtraNonChar: (value) => {
      if (!value) return ''
      if (value.includes('.')) {
        value = value.split('.')
        const valLength = value.length
        value = value[(valLength - 1)]
      }
      if (value.includes('_')) {
        value = value.replace(/_/g, ' ')
      }
      value = value.toLowerCase()
      return value
    }
  },
  watch: {
    page: {
      handler (newValue) {
        if (newValue > 1) {
          if (this.submitSearch) {
            this.from = (newValue * this.pageSize) - this.pageSize
            this.submitSearch()
          }
        } else {
          if (this.submitSearch) {
            this.from = 0
            this.submitSearch()
          }
        }
      }
    },
    pageSize: {
      handler () {
        if (this.submitSearch) this.submitSearch()
      }
    }
  },
  created () {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  computed: {
    tableSize () {
      return this.windowHeight - this.nonTableHeight
    }
  },
  methods: {
    previous () {
      if (this.page > 1) {
        this.page = this.page - 1
      }
    },
    next () {
      this.page = this.page + 1
    },
    resize () {
      this.windowHeight = window.innerHeight
    },
    tableChange (searchFunc) {
      return function () {
        searchFunc()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/table.js